import { render, staticRenderFns } from "./MessageTip.vue?vue&type=template&id=f907462c&scoped=true&"
import script from "./MessageTip.vue?vue&type=script&lang=ts&"
export * from "./MessageTip.vue?vue&type=script&lang=ts&"
import style0 from "./MessageTip.vue?vue&type=style&index=0&id=f907462c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f907462c",
  null
  
)

export default component.exports